var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.load,
          expression: "load"
        }
      ]
    },
    [
      _vm.mostrarNenhumVinculado
        ? _c("div", { staticClass: "center" }, [
            _c("span", [_vm._v("Nenhum processo vinculado.")])
          ])
        : _vm.mostrarMensagemExportarCsvMa
        ? _c("div", { staticClass: "center" }, [
            _c("span", [
              _vm._v(
                "Para visualização dos processos vinculados do tipo REURB individual, exporte o CSV."
              )
            ])
          ])
        : _c("div", [
            _c(
              "div",
              [
                _c(
                  "el-collapse",
                  {
                    model: {
                      value: _vm.processoSelecionado,
                      callback: function($$v) {
                        _vm.processoSelecionado = $$v
                      },
                      expression: "processoSelecionado"
                    }
                  },
                  _vm._l(_vm.processos, function(processo) {
                    return _c(
                      "el-collapse-item",
                      {
                        key: processo.id,
                        attrs: { title: processo.numeroProcesso }
                      },
                      [
                        _c(
                          "el-card",
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("strong", [_vm._v("Numero do processo:")]),
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(processo.numeroProcesso)
                                    )
                                  ])
                                ]),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("strong", [
                                    _vm._v("Nome do interessado:")
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          processo.nomeRazaoSocialInteressado
                                        )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("strong", [
                                    _vm._v("CPF/CNPJ do interessado:")
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(processo.cpfCnpjInteressado)
                                    )
                                  ])
                                ]),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("strong", [_vm._v("Setor Atual:")]),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.setores[processo.setor] || " - "
                                        )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("strong", [_vm._v("Situação atual:")]),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (_vm.listaStatus &&
                                            _vm.listaStatus.find(function(
                                              status
                                            ) {
                                              return (
                                                status.codigo ===
                                                processo.status
                                              )
                                            }).nome) ||
                                            " - "
                                        )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]),
      _vm.mostrarBotaoExportar
        ? _c(
            "div",
            { staticClass: "exportar" },
            [
              _c("el-button", { on: { click: _vm.getCsv } }, [
                _vm._v("Exportar CSV")
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7008381e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7008381e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppVisualizarProcessosVinculadosTab.vue
// module id = null
// module chunks = 